export const getDiscountBannerContent = ({
    flagValue,
    storeCode,
    productBrand,
    discountBanner,
}) => {
    const uniqueBrandContent = productBrand && discountBanner.uniqueBrandContent?.[productBrand];
    const uniqueStoreContent = discountBanner.uniqueStoreContent?.[storeCode];
    const content =
        (uniqueBrandContent?.text && uniqueBrandContent) ||
        (uniqueStoreContent?.text && uniqueStoreContent) ||
        discountBanner?.[flagValue] ||
        {};
    return { feedbackBannerText: content.text, feedbackBannerCopyableText: content.copyableText };
};
